import { useChatApiClient } from "@trinity/chat-components/containers/Chat/useApiClient.js";
import { CreateChartPreferencesRecord, CreateChartPreferencesRecordContext, UpdateChartPreferencesContext, UpdateChartPreferencesOverride } from "@trinity/chat-components/containers/ChartPreferences/context.js";

type Props = {
  children: React.ReactNode;
};

export const ChartRecordsContainer = (props: Props) => {

  const apiClient = useChatApiClient();

  return (
    <UpdateChartPreferencesContext.Provider value={apiClient.chatCharts.updateChartRecordOverride as UpdateChartPreferencesOverride}>
      <CreateChartPreferencesRecordContext.Provider value={apiClient.chatCharts.createChartRecord as CreateChartPreferencesRecord}>
        {props.children}
      </CreateChartPreferencesRecordContext.Provider>
    </UpdateChartPreferencesContext.Provider>
  );
};